import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../../../themes/palette"

export const useStyles = makeStyles()(({ spacing, typography }) => ({
  root: {
    padding: spacing(3, 5),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  textContainer: {
    display: "flex",
    gap: spacing(4),
    alignItems: "center"
  },
  iconContainer: {
    width: typography.pxToRem(16),
    height: typography.pxToRem(16),
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  icon: {
    color: blueGrey[500]
  }
}))
